import palette from '../palette';

export default {
  root: {
    fontSize: 12,
    borderBottom: `1px solid ${palette.divider}`,
  },
};
